"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageDeliveryFailReason = exports.MessageDeliveryStatus = exports.AgentDevicePlatform = exports.AgentDeviceType = exports.VisitorStatus = exports.ChatReadInfoType = exports.ChatStatus = exports.AgentStatus = exports.AccountStatus = void 0;
exports.AccountStatus = {
    Online: 'online',
    Offline: 'offline',
};
exports.AgentStatus = {
    Online: 'online',
    Offline: 'offline',
};
exports.ChatStatus = {
    Pending: 'pending',
    Open: 'open',
    Closed: 'closed',
    Served: 'served',
};
exports.ChatReadInfoType = {
    Agent: 'agent',
    Contact: 'contact',
};
exports.VisitorStatus = {
    Active: 'active',
    Clicked: 'clicked',
    Idle: 'idle',
    Served: 'served',
    Unserved: 'unserved',
    Triggered: 'triggered',
};
exports.AgentDeviceType = {
    Browser: 'browser',
    Mobile: 'mobile',
    Xmpp: 'xmpp',
    Other: 'other',
};
exports.AgentDevicePlatform = {
    IOS: 'ios',
    ANDROID: 'android',
};
exports.MessageDeliveryStatus = {
    Ok: 'ok',
    PermanentFail: 'permanent_fail',
    TemporaryFail: 'temporary_fail',
    Complained: 'complained',
    Seen: 'seen',
};
exports.MessageDeliveryFailReason = {
    Facebook24hWindow: 'facebook.outside_allowed_window',
    WhatsappUnsupportedFile: 'whatsapp.unsupported_file_type',
    WhatsappUnknown: 'whatsapp.unknown',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxhQUFhLEdBQUc7SUFDNUIsTUFBTSxFQUFFLFFBQVE7SUFDaEIsT0FBTyxFQUFFLFNBQVM7Q0FDVCxDQUFBO0FBR0csUUFBQSxXQUFXLEdBQUc7SUFDMUIsTUFBTSxFQUFFLFFBQVE7SUFDaEIsT0FBTyxFQUFFLFNBQVM7Q0FDVCxDQUFBO0FBR0csUUFBQSxVQUFVLEdBQUc7SUFDekIsT0FBTyxFQUFFLFNBQVM7SUFDbEIsSUFBSSxFQUFFLE1BQU07SUFDWixNQUFNLEVBQUUsUUFBUTtJQUNoQixNQUFNLEVBQUUsUUFBUTtDQUNQLENBQUE7QUFHRyxRQUFBLGdCQUFnQixHQUFHO0lBQy9CLEtBQUssRUFBRSxPQUFPO0lBQ2QsT0FBTyxFQUFFLFNBQVM7Q0FDVCxDQUFBO0FBR0csUUFBQSxhQUFhLEdBQUc7SUFDNUIsTUFBTSxFQUFFLFFBQVE7SUFDaEIsT0FBTyxFQUFFLFNBQVM7SUFDbEIsSUFBSSxFQUFFLE1BQU07SUFDWixNQUFNLEVBQUUsUUFBUTtJQUNoQixRQUFRLEVBQUUsVUFBVTtJQUNwQixTQUFTLEVBQUUsV0FBVztDQUNiLENBQUE7QUFHRyxRQUFBLGVBQWUsR0FBRztJQUM5QixPQUFPLEVBQUUsU0FBUztJQUNsQixNQUFNLEVBQUUsUUFBUTtJQUNoQixJQUFJLEVBQUUsTUFBTTtJQUNaLEtBQUssRUFBRSxPQUFPO0NBQ0wsQ0FBQTtBQUdHLFFBQUEsbUJBQW1CLEdBQUc7SUFDbEMsR0FBRyxFQUFFLEtBQUs7SUFDVixPQUFPLEVBQUUsU0FBUztDQUNULENBQUE7QUFHRyxRQUFBLHFCQUFxQixHQUFHO0lBQ3BDLEVBQUUsRUFBRSxJQUFJO0lBQ1IsYUFBYSxFQUFFLGdCQUFnQjtJQUMvQixhQUFhLEVBQUUsZ0JBQWdCO0lBQy9CLFVBQVUsRUFBRSxZQUFZO0lBQ3hCLElBQUksRUFBRSxNQUFNO0NBQ0gsQ0FBQTtBQUdHLFFBQUEseUJBQXlCLEdBQUc7SUFDeEMsaUJBQWlCLEVBQUUsaUNBQWlDO0lBQ3BELHVCQUF1QixFQUFFLGdDQUFnQztJQUN6RCxlQUFlLEVBQUUsa0JBQWtCO0NBQzFCLENBQUEifQ==